import { useEffect, useState } from 'react';

import { acceptInsuranceService } from '../../api/acceptInsurance';
import { useAppDispatch } from '../../hooks';
import useArnFromPath from '../../hooks/useArnFromPath';
import useSettings from '../../hooks/useSettings';
import { getApplicationState } from '../../store/application/application';
import ErrorPage from '../ErrorPage/ErrorPage';
import StatusProcessingPage from '../StatusPage/ProcessingPage/StatusProcessingPage';

const PpiAutoDecline = () => {
    const dispatch = useAppDispatch();
    const { apiKey, proxyBaseUrl } = useSettings();
    const applicationReferenceNumber = useArnFromPath();
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (!apiKey || !proxyBaseUrl || !applicationReferenceNumber) {
            return;
        }

        let cancelled = false;

        const declineInsurance = async () => {
            try {
                await acceptInsuranceService(proxyBaseUrl, apiKey, applicationReferenceNumber, false);
                if (!cancelled) {
                    await dispatch(getApplicationState({ applicationReferenceNumber: applicationReferenceNumber }));
                }
            } catch {
                if (!cancelled) {
                    setIsError(true);
                }
            }
        };

        declineInsurance();

        return () => {
            cancelled = true;
        };
    }, [apiKey, applicationReferenceNumber, dispatch, proxyBaseUrl]);

    if (isError) {
        return <ErrorPage />;
    }

    return <StatusProcessingPage />;
};

export default PpiAutoDecline;
